import React, { useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Button } from "@mui/material";

import styles from "../assets/css/style.module.scss";
// import giftbagIcon from "../assets/img/giftbag.svg";
// import cart from "../assets/img/signupv2/willow/cart.svg";
// import earn from "../assets/img/earn.svg";

import { remittanceRateCardClicked } from "../libs/events";
import TcQR from "../assets/img/tc_qr.png";
import {
  countdown,
  formatPhoneNumber,
  formatUsPhoneToString,
  validatePhone,
} from "../libs/utils";
import { sendMeLink, verifyPasswordReset } from "../services/auth";
import { nonLoggedInExchangeRate } from "../services/remittance";
import AppSkeleton from "../components/Skeletons/AppSkeleton";
import { baseColor, highlightColor } from "../constants/skeletonColor";
import CrickBuzzFxCard from "./cricbuzz/CrickBuzzFxCard";
import { ABOUND_STATS } from "../constants";

function WillowSignupSuccess() {
  const [searchParams] = useSearchParams();
  const { state } = useLocation();

  const id = searchParams.get("id");
  const token = searchParams.get("token");
  const design_variant = searchParams.get("design_variant") || "v2";
  const { appLinkToken } = state || {};
  // const action_type = searchParams.get("action_type");

  // const [appLinkToken, setAppLinkToken] = useState();
  const [error, setError] = useState(null);
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState(null);
  const [linkSent, setLinkSent] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [fxRateData, setFxRateData] = useState({});

  const countdownRef = useRef();
  const inputRef = useRef();

  const { display_base_fx, display_promo_fx } = fxRateData || {};
  const isVersionv1 = design_variant === "v1";
  console.log("isVersionv1", isVersionv1);
  const getExchangeRate = async () => {
    try {
      setIsLoading(true);
      const exchangeRate = await nonLoggedInExchangeRate();
      if (exchangeRate) {
        setFxRateData(exchangeRate);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const handlePhone = (e) => {
    const phone = formatPhoneNumber(e.target.value);
    setPhone(phone);
  };

  const handleClick = () => {
    setMessage("");
    if (validatePhone(phone) && token) {
      sendMeLink({
        notification_method: "SMS",
        identifier: formatUsPhoneToString(phone),
        token: appLinkToken,
        user_identifier: id,
      })
        .then((response) => {
          if (response?.success) {
            setMessage(response.message);
            setPhone("");
            setLinkSent(true);
          }
        })
        .catch((error) => {
          inputRef.current.classList.add(styles.animateShake);
          setTimeout(() => {
            inputRef.current.classList.remove(styles.animateShake);
          }, 500);
          if (error?.response?.data?.error?.message == 0) {
            setError("Oops! Something went wrong");
          } else {
            setError(
              error?.response?.data?.error?.message
                ? error?.response?.data?.error?.message
                : error.message
            );
          }
        });
    } else {
      inputRef.current.querySelector("input").focus();
      inputRef.current.classList.add(styles.animateShake);
      setTimeout(() => {
        inputRef.current.classList.remove(styles.animateShake);
      }, 500);
    }
  };

  const handleSendMoney = () => {
    localStorage.setItem("token", "");
    remittanceRateCardClicked({ source: "willow_signup_success" });
    window.open(
      `${process.env.REACT_APP_TC_URL}/getapp/login?type=email&source=remittance&utm_source=willow`
    );
  };

  useEffect(() => {
    verifyPasswordReset({
      id: id,
      token: appLinkToken,
      action_type: "SEND_APP_LINK",
    })
      .then((response) => {
        console.log("response", response);
      })
      .catch((error) => {
        if (error?.response?.data?.error?.message == 0) {
          setError("Oops! Something went wrong");
        } else {
          setError(
            error?.response?.data?.error?.message
              ? error?.response?.data?.error?.message
              : error.message
          );
        }
      });
    countdown(1800, countdownRef);
    getExchangeRate();
  }, []);

  return (
    <div className={styles.willow}>
      <div className={styles.container}>
        <div className={styles.signupBox}>
          <div className={styles.aboundWillowLogo}>
            <img
              src={
                "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/aboundWillow.png"
              }
              alt="aboundWillow"
            />
          </div>
          <div
            className={`${styles.contentBox} ${
              isVersionv1 ? styles.contentBoxV1 : ""
            }`}
          >
            <div className={styles.leftBox}>
              <div
                className={`${styles.successMessage} ${
                  isVersionv1 ? styles.successMessageV1 : ""
                }`}
              >
                Success! Your cash back is credited
              </div>
              {/* <div className={styles.downloadMessage}>
                Download the Abound app, log to{" "}
                <span className={styles.successMessage}>
                  claim your cash back
                </span>
                —plus a $5 welcome bonus!
              </div> */}

              <div
                className={`${styles.downloadMessage} ${
                  isVersionv1 ? styles.downloadMessageV1 : ""
                }`}
              >
                Download the Abound app, log in to{" "}
                <span className={styles.highlighed}>claim your</span>
              </div>
              <div
                className={`${styles.downloadMessageLine2} ${
                  isVersionv1 ? styles.downloadMessageV1 : ""
                }`}
              >
                <span className={styles.highlighed}>cash back</span>
                —plus a $5 welcome bonus!
              </div>

              {/* <div className={styles.countdownContainer}>
                <div className={styles.cdLeftSection}>
                  <img src={giftbagIcon} />
                  $5 welcome bonus
                </div>
                <div>
                  Claim in <span ref={countdownRef}>29m 36s</span>
                </div>
              </div> */}
              <div className={isVersionv1 ? styles.downloadBox : ""}>
                <div
                  className={`${styles.appDownloadBox} ${
                    isVersionv1 ? styles.appDownloadBoxV1 : ""
                  }`}
                >
                  <div
                    className={`${styles.qrBox} ${
                      isVersionv1 ? styles.qrBoxV1 : ""
                    }`}
                  >
                    <img src={TcQR} alt="QR" />
                  </div>
                  <div
                    className={`${styles.noInputBox} ${
                      isVersionv1 ? styles.noInputBoxV1 : ""
                    }`}
                  >
                    <div
                      className={`${styles.downloadText} ${
                        isVersionv1 ? styles.downloadTextV1 : ""
                      }`}
                    >
                      Scan QR or get the app download link via SMS
                    </div>
                    <div className={styles.formContainer}>
                      <div>
                        <div className={styles.inputControl} ref={inputRef}>
                          <div className={styles.numberPrefix}>+1</div>
                          <input
                            value={phone}
                            onChange={handlePhone}
                            placeholder="Phone number"
                            className={styles.input}
                            disabled={linkSent}
                          />
                        </div>

                        {/* <div>{message}</div> */}
                        {(error || message) && (
                          <div
                            className={
                              styles[error ? "inputError" : "inputInfoSuccess"]
                            }
                          >
                            {error ? error : message}
                          </div>
                        )}
                      </div>

                      <Button
                        type="submit"
                        className={`${styles.btnGolden} ${styles.textBlack}`}
                        onClick={handleClick}
                        disabled={linkSent}
                        endIcon={
                          <img
                            className={styles.arrow}
                            src={
                              "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/arrow-right-line.svg"
                            }
                            width="20"
                            height="20"
                          />
                        }
                      ></Button>
                    </div>
                  </div>
                </div>
                {/* <div className={styles.otherBenefits}>
                Enjoy other benefits from using the Abound App
              </div> */}
                <div
                  className={`${styles.upperContainer} ${
                    styles.otherBenefitsList
                  } ${isVersionv1 ? styles.upperContainerV1 : ""}`}
                >
                  {ABOUND_STATS.map((stat, index) => {
                    const isLast = index === ABOUND_STATS.length - 1;
                    return (
                      <div
                        className={`${styles.item} ${
                          isVersionv1 ? styles.itemV1 : ""
                        }`}
                        key={index}
                      >
                        <div className={styles.upperSection}>
                          <div className={styles.itemSubTitle}>
                            {stat.value}
                          </div>
                        </div>
                        <div className={styles.bottomSection}>{stat.label}</div>
                        {isVersionv1 && !isLast && (
                          <div className={styles.divider}></div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
              {isVersionv1 && (
                <div className={styles.fxCardContainer}>
                  <CrickBuzzFxCard
                    display_base_fx={display_base_fx}
                    display_promo_fx={display_promo_fx}
                    isFetchingRate={loading}
                  />
                </div>
              )}
            </div>
            {!isVersionv1 && (
              <div className={styles.rightBox}>
                <div>
                  <div className={styles.sendMoneyText}>
                    Send money to India at the best FX rates
                  </div>
                  <div className={styles.noDownloadText}>
                    — no app download required.
                  </div>
                  <div className={styles.promoBox}>
                    <div className={styles.backgroundPattern}></div>
                    <div className={styles.promoText}>
                      Promotional Exchange Rate
                    </div>
                    <div className={styles.rateBox}>
                      <span className={styles.highlighted}>$1=</span>
                      {loading ? (
                        <span>
                          <AppSkeleton
                            height={24}
                            width={72}
                            baseColor={baseColor}
                            highlightColor={highlightColor}
                            className={styles.fxSkeleton}
                          />
                        </span>
                      ) : (
                        <>
                          <span className={styles.striked}>
                            {display_base_fx}
                          </span>
                          <span className={styles.highlighted}>
                            {display_promo_fx}
                          </span>
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    className={styles.sendMoneyBtn}
                    onClick={handleSendMoney}
                  >
                    Send Money Now
                  </div>
                  {/* <div className={styles.separator}>
                  <div className={styles.line}></div>
                  <span className={styles.text}>OR</span>
                  <div className={styles.line}></div>
                </div>
                <div className={styles.joinaboundLink}>
                  <span>Visit:</span>{" "}
                  <span>
                    <a href="https://www.joinabound.com" target="_blank">
                      www.joinabound.com
                    </a>
                  </span>{" "}
                  <span>to learn more</span>
                </div> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WillowSignupSuccess;
